// extracted by mini-css-extract-plugin
module.exports = {"TextBlock":"TextBlock_TextBlock__xoYKM","Block":"TextBlock_Block__bY_fy","Description":"TextBlock_Description__M0Py8"};